/**
 * Status de pagamento da plataforma: valores, rótulo e cor.
 *
 * Estava declarado dentro de `organisms/FinancialTable/useFinancialTable.tsx`, que
 * importa `hooks/financial` → `FinancialTable` → `FinancialHeader` →
 * `useFinancialTable`. O ciclo funciona quando a aplicação entra pelo financeiro,
 * mas quem importa de fora recebe o enum ainda `undefined` e o
 * `Object.values(PaymentStatus)` do FinancialHeader estoura na carga do módulo.
 *
 * Aqui não há ciclo, então qualquer tela pode reaproveitar. O `useFinancialTable`
 * reexporta os três nomes, e por isso nenhum import existente muda.
 */

export enum PaymentStatus {
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  CHARGED_BACK = 'charged_back',
  IN_PROCESS = 'in_process',
  PENDING = 'pending',
  REFUNDED = 'refunded',
  REJECTED = 'rejected',
  PARTIAL_REFUND = 'partial_refund',
  MANUAL_ADJUSTMENT = 'manual_adjustment',
}

export const PaymentStatusText = {
  [PaymentStatus.APPROVED]: 'Pago',
  [PaymentStatus.CANCELLED]: 'Cancelado',
  [PaymentStatus.PENDING]: 'Pendente',
  [PaymentStatus.REFUNDED]: 'Reembolsado',
  [PaymentStatus.REJECTED]: 'Rejeitado',
  [PaymentStatus.CHARGED_BACK]: 'Estornado',
  [PaymentStatus.IN_PROCESS]: 'Em processamento',
  [PaymentStatus.PARTIAL_REFUND]: 'Devolução parcial',
  [PaymentStatus.MANUAL_ADJUSTMENT]: 'Manual',
};

export const PaymentStatusColor = {
  [PaymentStatus.APPROVED]: 'green',
  [PaymentStatus.REFUNDED]: 'blue',
  [PaymentStatus.IN_PROCESS]: 'gold',
  [PaymentStatus.PENDING]: 'volcano',
  [PaymentStatus.REJECTED]: 'red',
  [PaymentStatus.PARTIAL_REFUND]: 'cyan',
  [PaymentStatus.MANUAL_ADJUSTMENT]: 'purple',
};
